<template>
  <div>
    <el-dialog
      title="小程序管理"
      :visible.sync="dialogFormVisible"
      @close="emitClose"
      :close-on-click-modal="false"
      width="620px"
    >
      <el-form
        :model="dataForm"
        label-position="right"
        ref="formRules"
        :rules="rules"
        label-width="100px"
        size="small"
      >
        <el-form-item
          label="名称："
          prop="name"
        >
          <el-input
            v-model="dataForm.name"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="客户端Id："
          prop="appid"
        >
          <el-input
            v-model="dataForm.appid"
            placeholder="请输入客户端Id"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="广告封面："
          prop="icon_url"
        >
          <el-upload
            :action="imgUploadUrl"
            list-type="picture-card"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :file-list="fileList"
            :limit="1"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="简介："
          prop="description"
        >
          <el-input
            type="textarea"
            v-model="dataForm.description"
            placeholder="请输入简介"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="原始Id："
          prop="origin_id"
        >
          <el-input
            v-model="dataForm.origin_id"
            placeholder="请输入原始Id"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="跳转链接："
          prop="redirect_url"
        >
          <el-input
            v-model="dataForm.redirect_url"
            placeholder="请输入跳转链接"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="是否热门："
          prop="hot_status"
        >
          <el-radio-group v-model="dataForm.hot_status">
            <el-radio :label="0">非热门</el-radio>
            <el-radio :label="1">热门</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="排序值："
          prop="redirect_url"
        >
          <el-input-number v-model="dataForm.sort"></el-input-number>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="emitClose(false)">取消</el-button>
        <el-button
          type="primary"
          @click="submit('formRules')"
        >确定</el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>



import { imgUploadUrl, uploadHeaders } from '@/config/index'
import { createMiniProgram } from "@/api/operation";

export default {
  components: {
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      dataForm: {
        sort: 0,
        hot_status: 0,
      },
      rules: {
        name: [{ required: true, message: "请输入班级名称", trigger: "blur" }],
        appid: [{ required: true, message: "请输入客户端Id", trigger: "blur" }],
      /*   origin_id: [{ required: true, message: "请输入原始Id", trigger: "blur" }], */
        icon_url: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!this.fileList.length) {
              callback(new Error('请上传图片'))
            } else {
              callback()
            }
          },
        }],
      },
      imgUploadUrl: imgUploadUrl(),
      fileList: [],

    };
  },
  mounted() {

  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val;
    },
  },
  methods: {
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    handleSuccess(response, file, fileList) {
      this.fileList.push({
        url: response.data.url
      })
    },
    emitClose() {
      this.dataForm = {
        sort: 0,
        hot_status: 0,
      }
      this.fileList = []
      this.$emit("close");
    },
    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          let query = {
            name: this.dataForm.name,
            appid: this.dataForm.appid,
            icon_url: this.fileList.map(v => {
              return v.url
            }).join(','),
            description: this.dataForm.description,
            origin_id: this.dataForm.origin_id,
            redirect_url: this.dataForm.redirect_url,
            hot_status: this.dataForm.hot_status,
            sort: this.dataForm.sort,
          }
          createMiniProgram(query).then((res) => {
            this.$message.success(`添加成功`)

            this.$emit('submit')
            this.emitClose()
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>